import type { Quote } from "../../services/pulseService";
import { formatPrice, formatPercent, changeColor, formatVolume } from "./utils";

interface Props {
  gainers: Quote[];
  losers: Quote[];
  mostActive: Quote[];
}

type Tab = "gainers" | "losers" | "active";

import { useState } from "react";

export function MoversPanel({ gainers, losers, mostActive }: Props) {
  const [tab, setTab] = useState<Tab>("gainers");

  const tabs: { key: Tab; label: string; count: number }[] = [
    { key: "gainers", label: "Gainers", count: gainers.length },
    { key: "losers", label: "Losers", count: losers.length },
    { key: "active", label: "Most Active", count: mostActive.length },
  ];

  const list = tab === "gainers" ? gainers : tab === "losers" ? losers : mostActive;

  return (
    <div className="glass-card p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-surface-200 uppercase tracking-wider mb-3">
        Market Movers
      </h3>

      {/* Tab bar */}
      <div className="flex gap-1 p-1 rounded-lg bg-surface-800/60 mb-3">
        {tabs.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`flex-1 py-1.5 px-2 text-xs font-medium rounded-md transition-all ${
              tab === t.key
                ? "bg-primary-500/20 text-primary-400 border border-primary-500/30"
                : "text-surface-400 hover:text-surface-200"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="space-y-1 max-h-[320px] overflow-y-auto custom-scrollbar">
        {list.slice(0, 10).map((q) => (
          <div
            key={q.symbol}
            className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-surface-800/40 transition-colors"
          >
            <div className="flex flex-col min-w-0">
              <span className="text-sm font-semibold text-surface-100">{q.symbol}</span>
              <span className="text-xs text-surface-500 truncate max-w-[120px]">{q.name}</span>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm font-mono text-surface-200 tabular-nums hidden sm:block">
                {formatPrice(q.price)}
              </span>
              <span className={`text-sm font-semibold tabular-nums min-w-[60px] text-right ${changeColor(q.change_percent)}`}>
                {formatPercent(q.change_percent)}
              </span>
              <span className="text-xs text-surface-500 tabular-nums hidden md:block min-w-[50px] text-right">
                {formatVolume(q.volume)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
